import React from 'react';
import { Typography } from '@saviynt/design-system';

import './Header.css';

export default function Header() {
  return (
    <header className='Ext-Header' data-testid='ext-usermanagement-header'>
      <div className='Ext-Header-title'>
        <Typography kind='h2' desktop='display4-d' mobile='display4-d'>
          User Life-Cycle Management
        </Typography>
      </div>
    </header>
  );
}
